<template>
  <div class="lc-login">
    <!-- Lado esquerdo — imagem -->
    <div class="lc-login__left">
      <div class="lc-login__left-overlay"></div>
      <div class="lc-login__left-content">
        <div class="lc-login__brand">
          <!-- <span class="lc-login__brand-name">Reorganiza · Lead Center</span> -->
        </div>
        <div class="lc-login__left-text">
          <h2>As suas finanças<br />em boas mãos.</h2>
          <p>Plataforma de gestão de leads e consentimentos RGPD.</p>
        </div>
      </div>
    </div>

    <!-- Lado direito — form -->
    <div class="lc-login__right">
      <div class="lc-login__form-wrap">
        <div class="lc-login__form-header">
          <h1>Bem-vindo de volta</h1>
          <p>Introduza as suas credenciais para entrar.</p>
        </div>

        <form @submit.prevent="onSubmit" class="lc-login__form">
          <div class="lc-field">
            <label class="lc-field__label">E-mail</label>
            <input
              class="lc-input"
              type="email"
              v-model="formEmail"
              placeholder="o.seu@email.com"
              autocomplete="email"
            />
          </div>

          <div class="lc-field">
            <label class="lc-field__label">Password</label>
            <input
              class="lc-input"
              type="password"
              v-model="formPassword"
              placeholder="••••••••"
              autocomplete="current-password"
            />
          </div>

          <div class="lc-login__error" v-if="erro">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {{ mensagem_erro }}
          </div>

          <button class="lc-login__btn" type="submit" :disabled="loading">
            <span class="lc-login__btn-spinner" v-if="loading"></span>
            <span v-else>Entrar</span>
          </button>
        </form>

        <p class="lc-login__footer">© {{ ano }} Lead Center · Reorganiza</p>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api/index";

  export default {
    name: "vnud-login",
    data() {
      return {
        formEmail: "",
        formPassword: "",
        erro: false,
        loading: false,
        ano: new Date().getFullYear(),
        mensagem_erro: "Credenciais incorretas. Tente novamente.",
      };
    },
    methods: {
      async onSubmit() {
        if (!this.formEmail || !this.formPassword) return;
        this.loading = true;
        this.erro = false;
        const res = await api.login({
          email: this.formEmail,
          password: this.formPassword,
        });
        this.loading = false;
        if (res && res.user_id) {
          localStorage.setItem("lc_Dashboard_Login", JSON.stringify(res));
          location.replace("/");
        } else {
          this.erro = true;
        }
      },
    },
  };
</script>

<style scoped>
  /* ── Layout ── */
  .lc-login {
    display: flex;
    min-height: 100vh;
    width: 100%;
  }

  /* ── Esquerda ── */
  .lc-login__left {
    flex: 1;
    position: relative;
    background-image: url("/img/bg15.jpg");
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 40px;
    min-height: 100vh;
  }
  @media (max-width: 768px) {
    .lc-login__left {
      display: none;
    }
  }

  .lc-login__left-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(20, 23, 32, 0.85) 0%,
      rgba(78, 171, 62, 0.25) 100%
    );
  }

  .lc-login__left-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .lc-login__brand {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .lc-login__brand-name {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }
  .lc-login__logo {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
  }
  .lc-login__logo-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #032622, #054d44);
  }
  .lc-login__logo span {
    font-size: 13px;
    font-weight: 700;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .lc-login__left-text {
    margin-top: auto;
    padding-bottom: 20px;
  }
  .lc-login__left-text h2 {
    font-size: 36px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    margin: 0 0 12px;
  }
  .lc-login__left-text p {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
  }

  /* ── Direita ── */
  .lc-login__right {
    width: 460px;
    flex-shrink: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
  }
  @media (max-width: 768px) {
    .lc-login__right {
      width: 100%;
      min-height: 100vh;
    }
  }

  .lc-login__form-wrap {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
  }

  /* ── Header ── */
  .lc-login__form-header {
    margin-bottom: 32px;
  }
  .lc-login__form-header h1 {
    font-size: 26px;
    font-weight: 700;
    color: #111318;
    margin: 0 0 6px;
  }
  .lc-login__form-header p {
    font-size: 14px;
    color: #9ca3af;
    margin: 0;
  }

  /* ── Form ── */
  .lc-login__form {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .lc-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .lc-field__label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6b7280;
  }

  .lc-input {
    width: 100%;
    padding: 13px 16px;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    color: #111318;
    background: #f8f9fb;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
    outline: none;
    font-family: inherit;
  }
  .lc-input:focus {
    border-color: #4eab3e;
    box-shadow: 0 0 0 3px rgba(3, 38, 34, 0.08);
    background: #fff;
  }
  .lc-input::placeholder {
    color: #c4c9d4;
  }

  /* ── Error ── */
  .lc-login__error {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(192, 57, 43, 0.06);
    border: 1px solid rgba(192, 57, 43, 0.2);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 13px;
    color: #c0392b;
  }

  /* ── Button ── */
  .lc-login__btn {
    margin-top: 4px;
    width: 100%;
    padding: 13px;
    background: #032622;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.01em;
  }
  .lc-login__btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(3, 38, 34, 0.3);
  }
  .lc-login__btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  .lc-login__btn-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: lc-spin 0.7s linear infinite;
  }
  @keyframes lc-spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* ── Footer ── */
  .lc-login__footer {
    margin-top: 32px;
    font-size: 12px;
    color: #d1d5db;
    text-align: center;
  }
</style>
